<template>
  <banner-description
    title="services.whyChooseUs"
    titleColor="#603813"
    :starIconObj="{ componentName: 'shared', imgName: 'starIconSeaBlue', imgFormat: 'svg' }"
    :starBackgroundObj="{ componentName: 'shared', imgName: 'starGroupIconBrownLeft', imgFormat: 'svg', position: 'top:80%' }"
    description="services.whyChooseUsDesc"
    descColor="#4E4E4E"
    class="pb-24"
  />

  <egg-label-list :eggIconLabelList="servicesStore.whyChooseUsEggDescList"  class="pb-24" />
</template>

<script setup lang="ts">
import { useServicesStore } from "@/stores/services";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";

const servicesStore = useServicesStore();
const router = useRouter();

onMounted(async () => {});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>